import { Box } from '@mantine/core';

export interface CoverageBarProps {
  /** Percent 0..100. */
  value: number;
  /** Below this the geo cannot be generated for — drawn in the danger colour. */
  threshold?: number;
  /** What is being measured; a screen reader gets the number with its subject, not a bare %. */
  label?: string;
}

/**
 * Dictionary coverage bar.
 *
 * Colour is not decoration: below the generation threshold the bar is red because that is
 * a hard block, between threshold and 100 it is amber because generation will work but
 * terms will fall back to English.
 */
export function CoverageBar({
  value,
  threshold = 90,
  label = 'Покриття словника',
}: CoverageBarProps): React.JSX.Element {
  const clamped = Math.max(0, Math.min(100, value));
  const colour = clamped < threshold ? 'var(--r)' : clamped < 100 ? 'var(--a)' : 'var(--g)';

  return (
    <Box
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={`${label} ${String(clamped)}%`}
      style={{
        height: 6,
        borderRadius: 3,
        background: 'var(--track)',
        overflow: 'hidden',
      }}
    >
      <Box
        style={{
          width: `${String(clamped)}%`,
          height: '100%',
          background: colour,
          transition: 'width 160ms ease',
        }}
      />
    </Box>
  );
}
